module.exports = __webpack_public_path__ + "img/content_pc_ui1.81101f26.jpg";